/** Silent session refresh — trades the long-lived refresh token (httpOnly
 * cookie, with localStorage fallback for the installed PWA) for a fresh
 * 12h access token. Returns true on success. */
const API = process.env.REACT_APP_BACKEND_URL;

export const trySilentRefresh = async () => {
  try {
    const r = await fetch(`${API}/api/admin/auth/refresh_session`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: localStorage.getItem('kindra-admin-rt') || '' }),
    });
    const d = await r.json().catch(() => ({}));
    if (r.ok && d.token) {
      localStorage.setItem('kindra-admin-token', d.token);
      return true;
    }
    if (r.status === 401) localStorage.removeItem('kindra-admin-rt');
  } catch { /* network blip — caller decides */ }
  return false;
};

export const signOutEverywhere = async () => {
  try {
    await fetch(`${API}/api/admin/auth/logout`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: localStorage.getItem('kindra-admin-rt') || '' }),
    });
  } catch { /* revocation is best-effort client-side */ }
  localStorage.removeItem('kindra-admin-token');
  localStorage.removeItem('kindra-admin-rt');
};
